/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed, Jul 21st 2021, 5:35:33 pm
 *
 * *****************************************************
 */

import styled from 'styled-components';

export const H1 = styled.h1`
  @media (max-width: 31em) {
    width: 85%;
  }
`;

export const ContentContainer = styled.div`
  margin: 1.5rem 0 4rem;
  width: 100%;

  & > *:not(:first-child) {
    margin-top: 1.5rem;
  }
`;

export const Footer = styled.footer<{ confirmEmailIsLoading: boolean }>`
  margin-bottom: ${({ confirmEmailIsLoading }) => (confirmEmailIsLoading ? '1.1rem' : '1.5rem')};
`;
